import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Story from './pages/Story';
import About from './pages/About';
import Help from './pages/Help';
import usePageTracking from './usePageTracking';

function App() {
  usePageTracking();

  return (
    <div>
      <Navbar />
      <div className="h-24"></div> {/* Add padding to the top */}
      <Routes>
        <Route path="/" element={<About />} />
        <Route path="/story" element={<Story />} />
        <Route path="/about" element={<About />} />
        <Route path="/help" element={<Help />} />
      </Routes>
    </div>
  );
}

export default App;